
import { Grid, Typography, FormControl, TextField, MenuItem, Select, FormHelperText, Button, Modal,Autocomplete,Chip } from '@mui/material'
import { withStyles } from "@material-ui/core/styles"
import styles from "../../TabStyles"

const UsersForm = ({
    classes,
    handleCloseUser,
    newEmail,
    newName,
    setNewEmail,
    setNewName,
    setErrType,
    errType,
    errMsg,
    department,
    handleDepartmentChange,
    departmentData,
    secret,
    setSecret,
    sipGroupId,
    setSipGroupId,
    role,
    handleRoleChange,
    roleData,
    additionalRoles,
    handleAdditionalRoles,
    menuData,
    additionalError,
    editUser,
    CreateUser,
    EditUser,
    departmentError,
    roleError,
    addUserModal,
    franchList, // srini - 20/12/24
    franchaise,
    handleFranchaiseChange,
    franchError,
    contact,
    setContact
}) => {

    console.log("franchList", franchaise)
    return (

        <Modal
            className={classes.modalCard1}
            open={addUserModal}
            style={{ marginLeft: '320px', marginTop: '190px' }}

            BackdropProps={{
                style: {
                    backgroundColor: 'rgba(0, 0, 0, 0)'
                },

            }}
        >
            <Grid>
                <img
                    src={require('../../../../ui-assets/XFrame.png')}
                    alt=" X Icon"
                    onClick={handleCloseUser}
                    style={{
                        width: '24px', height: '24px', flexShrink: '0', marginLeft: '803px', marginTop: '13px', cursor: 'pointer'

                    }}
                />
                <div style={{ flex: '80%' }}>
                    <div style={{ display: 'flex' }}>
                        <div style={{ flex: '50%' }}>
                            <Grid Container style={{ marginTop: '1px', marginLeft: '30px' }}>
                                <Grid item>
                                    <Typography className={classes.formlabel1} >Email</Typography>
                                    <FormControl>
                                        <TextField
                                            placeholder='Enter Agent ID/Email'
                                            value={newEmail}
                                            InputProps={{

                                                style: {
                                                    width: '342px ',
                                                    height: '42px ',
                                                    backgroundColor: 'white',
                                                    flexShrink: 0,
                                                    color: '#333333',
                                                    fontFamily: 'cardiuma-regular',
                                                    fontSize: '12px',
                                                    fontStyle: 'normal',
                                                    fontWeight: '400',
                                                    lineHeight: '20px'
                                                }
                                            }}
                                            onChange={(e) => {
                                                setNewEmail(e.target.value)
                                                setErrType(0)
                                            }}

                                        />
                                        {errType === 1 &&
                                            <FormHelperText className={classes.errtxt} id="component-error-text">{errMsg}</FormHelperText>
                                        }
                                    </FormControl>
                                </Grid>

                                <Grid item>
                                    <Typography className={classes.formlabel1} style={{ paddingTop: '10px' }}>Name</Typography>
                                    <FormControl>
                                        <TextField
                                            value={newName}
                                            placeholder='Party 1 name'
                                            InputProps={{

                                                style: {
                                                    width: '342px ',
                                                    height: '42px ',
                                                    backgroundColor: 'white',
                                                    flexShrink: 0,
                                                    color: 'black',
                                                    fontFamily: 'cardiuma-regular',
                                                    fontSize: '12px',
                                                    fontStyle: 'normal',
                                                    fontWeight: '400',
                                                    lineHeight: '20px'
                                                }
                                            }}
                                            onChange={(e) => {
                                                setNewName(e.target.value)
                                                setErrType(0)
                                            }}

                                        />
                                        {errType === 2 &&
                                            <FormHelperText className={classes.errtxt} id="component-error-text">{errMsg}</FormHelperText>
                                        }
                                    </FormControl>
                                </Grid>

                                <Grid item style={{ paddingTop: '10px' }}>
                                    <Typography className={classes.formlabel1} >Contact No</Typography>
                                    <FormControl>
                                        
                                        <TextField
                                            placeholder='Enter Contact No'
                                            value={contact}
                                            inputProps={{
                                                maxLength: 10,
                                                inputMode: "numeric",
                                                pattern: "[0-9]*"
                                            }}
                                            InputProps={{

                                                style: {
                                                    width: '342px ',
                                                    height: '42px ',
                                                    backgroundColor: 'white ',
                                                    flexShrink: 0,
                                                    color: '#333333',
                                                    fontFamily: 'cardiuma-regular',
                                                    fontSize: '12px',
                                                    fontStyle: 'normal',
                                                    fontWeight: '400',
                                                    lineHeight: '20px'
                                                }
                                            }}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, ''); // remove non-numbers
                                                if (value.length <= 10) {
                                                    setContact(value);
                                                    setErrType(0);
                                                }
                                            }}

                                        />
                                        {errType === 5 &&
                                            <FormHelperText className={classes.errtxt} id="component-error-text">{errMsg}</FormHelperText>
                                        }
                                    </FormControl>
                                </Grid>

                                {/* <div style={{ paddingTop: '10px' }}>

                                    <FormControl>
                                        <Typography className={classes.formlabel1} style={{ color: departmentError ? 'red' : '#333333' }}>Department</Typography>
                                        <Select
                                            displayEmpty
                                            variant="outlined"
                                            size="small"
                                            value={department}
                                            multiple
                                            placeholder='Select...'
                                            style={{ height: '41px', width: '342px' }}
                                            inputProps={{
                                                style: { fontSize: '14px', background: '#ffffff', height: '20px' },


                                            }}
                                            option
                                            onChange={handleDepartmentChange}

                                        >
                                            <MenuItem value='0' className={classes.inputtext1} >
                                                Select...
                                            </MenuItem>

                                            {departmentData.map((item) => (
                                                <MenuItem
                                                    key={item.uid}
                                                    value={item.uid}
                                                    className={classes.inputtext1}

                                                    sx={{
                                                        '&.Mui-selected': {
                                                            backgroundColor: '#999',
                                                            color: '#fff',
                                                        },
                                                        '&.Mui-selected:hover': {
                                                            backgroundColor: '#999',
                                                        },
                                                        '&:hover': {
                                                            backgroundColor: '#d6d6d6',
                                                        },
                                                    }}
                                                >
                                                    {item.name}
                                                </MenuItem>
                                            ))}

                                        </Select>

                                    </FormControl>

                                </div> */}


                                <div style={{ paddingTop: '10px' }}>
                                    <FormControl style={{ width: '342px' }}>
                                        <Typography
                                            className={classes.formlabel1}
                                            style={{ color: departmentError ? 'red' : '#333333' }}
                                        >
                                            Department
                                        </Typography>
                                        <Autocomplete
                                            multiple
                                            id="department-tags"
                                            value={department || []}
                                            onChange={handleDepartmentChange}
                                            options={departmentData.map(item => item.uid)}
                                            getOptionLabel={(option) => {
                                                const depItem = departmentData.find(d => d.uid === option);
                                                return depItem ? depItem.name : option;
                                            }}
                                            renderTags={(selected, getTagProps) =>
                                                selected.map((option, index) => {
                                                    const depItem = departmentData.find(d => d.uid === option);
                                                    return (
                                                        <Chip
                                                            key={option}
                                                            label={depItem ? depItem.name : option}
                                                            {...getTagProps({ index })}
                                                        />
                                                    );
                                                })
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select..."
                                                    size="small"
                                                    error={departmentError}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </div>

                                {/* srini - 20/12/24 */}
                             
                            </Grid>
                        </div>
                        <div style={{ flex: '50%' }}>

                            <Grid Container style={{ marginTop: '1px', marginLeft: '30px' }}>
                                <Grid item>
                                    <Typography className={classes.formlabel1} >Secret</Typography>
                                    <FormControl>
                                        <TextField
                                            type="password"
                                            placeholder='Enter PIN'
                                            value={secret}
                                            InputProps={{
                                                style: {
                                                    width: '342px ',
                                                    height: '42px ',
                                                    backgroundColor: 'white ',
                                                    flexShrink: 0,
                                                    color: '#333333',
                                                    fontFamily: 'cardiuma-regular',
                                                    fontSize: '12px',
                                                    fontStyle: 'normal',
                                                    fontWeight: '400',
                                                    lineHeight: '20px'
                                                }
                                            }}
                                            onChange={(e) => {
                                                setSecret(e.target.value)
                                                setErrType(0)
                                            }}

                                        />
                                        {errType === 3 &&
                                            <FormHelperText className={classes.errtxt} id="component-error-text">{errMsg}</FormHelperText>
                                        }
                                    </FormControl>
                                </Grid>

                                <Grid item style={{ paddingTop: '10px' }}>
                                    <Typography className={classes.formlabel1} >Sip Id</Typography>
                                    <FormControl>
                                        <TextField
                                            placeholder='Enter Sip Id'
                                            value={sipGroupId}
                                            InputProps={{

                                                style: {
                                                    width: '342px ',
                                                    height: '42px ',
                                                    backgroundColor: 'white ',
                                                    flexShrink: 0,
                                                    color: '#333333',
                                                    fontFamily: 'cardiuma-regular',
                                                    fontSize: '12px',
                                                    fontStyle: 'normal',
                                                    fontWeight: '400',
                                                    lineHeight: '20px'
                                                }
                                            }}
                                            onChange={(e) => {
                                                setSipGroupId(e.target.value)
                                                setErrType(0)
                                            }}

                                        />
                                        {errType === 4 &&
                                            <FormHelperText className={classes.errtxt} id="component-error-text">{errMsg}</FormHelperText>
                                        }
                                    </FormControl>
                                </Grid>

                                {/* <div style={{ paddingTop: '10px' }}>
                                    <FormControl>
                                        <Typography className={classes.formlabel1} style={{ color: roleError ? 'red' : '#333333' }}>Role</Typography>
                                        <Select
                                            displayEmpty
                                            variant="outlined"
                                            size="small"
                                            value={role}
                                            placeholder='Select...'
                                            multiple
                                            style={{ height: '41px', width: '342px' }}
                                            inputProps={{
                                                style: { fontSize: '14px', background: '#ffffff', height: '20px' },
                                            }}
                                            option
                                            onChange={handleRoleChange}

                                        >
                                            <MenuItem value='0' className={classes.inputtext1} >
                                                Select...
                                            </MenuItem>

                                            {roleData.map((item) => (
                                                <MenuItem
                                                    key={item.uid}
                                                    value={item.uid}
                                                    className={classes.inputtext1}

                                                    sx={{
                                                        '&.Mui-selected': {
                                                            backgroundColor: '#999',
                                                            color: '#fff',
                                                        },
                                                        '&.Mui-selected:hover': {
                                                            backgroundColor: '#999',
                                                        },
                                                        '&:hover': {
                                                            backgroundColor: '#d6d6d6',
                                                        },
                                                    }}
                                                >
                                                    {item.name}
                                                </MenuItem>
                                            ))}

                                        </Select>
                                    </FormControl>
                                </div> */}

                                <div style={{ paddingTop: '10px' }}>
                                    <FormControl style={{ width: '342px' }}>
                                        <Typography
                                            className={classes.formlabel1}
                                            style={{ color: roleError ? 'red' : '#333333' }}
                                        >
                                            Role
                                        </Typography>
                                        <Autocomplete
                                            multiple
                                            id="role-tags"
                                            value={role || []}
                                            onChange={handleRoleChange}
                                            options={roleData.map(item => item.uid)}
                                            getOptionLabel={(option) => {
                                                const roleItem = roleData.find(r => r.uid === option);
                                                return roleItem ? roleItem.name : option;
                                            }}
                                            renderTags={(selected, getTagProps) =>
                                                selected.map((option, index) => {
                                                    const roleItem = roleData.find(r => r.uid === option);
                                                    return (
                                                        <Chip
                                                            key={option}
                                                            label={roleItem ? roleItem.name : option}
                                                            {...getTagProps({ index })}
                                                        />
                                                    );
                                                })
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select..."
                                                    size="small"
                                                    error={roleError}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </div>


                                            {/* New Field srini - 20/12/24 */}
                                {/* <div style={{ paddingTop: '10px' }}>
                                    <FormControl>
                                        <Typography className={classes.formlabel1} style={{ color: franchError ? 'red' : '#333333' }}>Franchaisee</Typography>
                                        <Select
                                            displayEmpty
                                            variant="outlined"
                                            size="small"
                                            value={franchaise}
                                            placeholder='Select...'
                                            multiple
                                            style={{ height: '41px', width: '342px' }}
                                            inputProps={{
                                                style: { fontSize: '14px', background: '#ffffff', height: '20px' },
                                            }}
                                            option
                                            onChange={handleFranchaiseChange}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) {
                                                    return <em>Select...</em>; // show placeholder if no selection
                                                }
                                                return selected.join(', ');
                                            }}

                                        >
                                            <MenuItem value='' className={classes.inputtext1}>
                                                Select...
                                            </MenuItem>

                                            {franchList.map((item) => (
                                                <MenuItem
                                                    key={item.uid}
                                                    value={item.franchisee_code}
                                                    className={classes.inputtext1}

                                                    sx={{
                                                        '&.Mui-selected': {
                                                            backgroundColor: '#999',
                                                            color: '#fff',
                                                        },
                                                        '&.Mui-selected:hover': {
                                                            backgroundColor: '#999',
                                                        },
                                                        '&:hover': {
                                                            backgroundColor: '#d6d6d6',
                                                        },
                                                    }}
                                                >
                                                    {item.franchisee_code}
                                                </MenuItem>
                                            ))}

                                        </Select>
                                    </FormControl>
                                </div> */}

                                <div style={{ paddingTop: '10px' }}>

                                    <FormControl style={{ width: '342px' }}>
                                        <Typography
                                            className={classes.formlabel1}
                                            style={{ color:  '#333333' }}
                                        >
                                            Additional role (agent menu)
                                        </Typography>
                                        <Autocomplete
                                            multiple
                                            id="role-tags"
                                            value={additionalRoles || []}
                                            onChange={handleAdditionalRoles}
                                            options={menuData.map(item => item.uid)}
                                            getOptionLabel={(option) => {
                                                const roleItem = menuData.find(r => r.uid === option);
                                                return roleItem ? roleItem.name : option;
                                            }}
                                            renderTags={(selected, getTagProps) =>
                                                selected.map((option, index) => {
                                                    const roleItem = menuData.find(r => r.uid === option);
                                                    return (
                                                        <Chip
                                                            key={option}
                                                            label={roleItem ? roleItem.name : option}
                                                            {...getTagProps({ index })}
                                                        />
                                                    );
                                                })
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select..."
                                                    size="small"
                                                    error={additionalError}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </div>

                                {/* <div style={{ paddingTop: '10px' }}>
                                    <FormControl style={{ width: '342px' }}>
                                        <Typography className={classes.formlabel1} style={{ color: franchError ? 'red' : '#333333' }}>
                                            Franchisee
                                        </Typography>
                                        <Autocomplete
                                            multiple
                                            id="franchisee-tags"
                                            value={franchaise || []}
                                            onChange={handleFranchaiseChange}
                                            options={franchList.map(item => item.franchisee_code)}
                                            getOptionLabel={(option) => option}
                                            renderTags={(selected, getTagProps) =>
                                                selected.map((option, index) => (
                                                    <Chip key={option} label={option} {...getTagProps({ index })} />
                                                ))
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select..."
                                                    size="small"
                                                    error={franchError}
                                                />
                                            )}
                                        />

                                    </FormControl>
                                </div> */}

                            </Grid>
                        </div>
                    </div>
                </div>
                
                <div style={{ flex: '20px' }}>
                    <Button style={{ backgroundColor: '#F3D45E', width: '136px', height: '42px', marginLeft: '652px', marginTop: '25px' }} onClick={editUser ? EditUser : CreateUser}>
                        <span style={{ color: '#3E3E3E', textTransform: 'none' }} >Save</span>
                    </Button>
                </div>
            </Grid>
        </Modal>
    )
}

export default withStyles(styles)(UsersForm)
